import { type BlockConfiguration, registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import { Edit } from './edit';
import { Icon } from './icon';
import { type CustomerInfoAttributes } from './types';

const settings: BlockConfiguration< CustomerInfoAttributes > = {
	...( metadata as BlockConfiguration< CustomerInfoAttributes > ),
	icon: Icon,
	edit: Edit,
};

registerBlockType< CustomerInfoAttributes >( metadata.name, settings );
